import type { Provider } from '@angular/core';
import { BROADCAST_PUBLISHER_PREVIEW_PROVIDERS } from '../../settings/pages/broadcast/broadcast-publisher-preview.providers';

/** Both public review routes use the same wire fixtures, clock and pinned
 * location initializer. The component owns its identity, feature flags and
 * publisher together; route dependencies must import no rendering component. */
export const FRONT_PAGE_STUDIO_PREVIEW_PROVIDERS: Provider[] = [
  ...BROADCAST_PUBLISHER_PREVIEW_PROVIDERS,
];
